import styled from 'styled-components'

const formatSize = size => (typeof size === 'string' ? size : `${size}px`)

export const Container = styled(({ type, size, innerRef, ...props }) => (
  <div {...props} ref={innerRef} />
))`
  ${({ type, size }) =>
    type === 'vertical'
      ? `
    height: ${formatSize(size)};
    width: 100%;
  `
      : `
    width: ${formatSize(size)};
    height: 100%;
  `}
`
